import lazyScripts from "../services/lazy-scripts";
import http from "../services/http";

/**
 * @param props
 */

export default (props) => {
    return {
        currentLevel: 1,
        nativeHlsed: false,
        isWebkit: navigator.Agent.indexOf('AppleWebKit') !== -1,
        hlsObject: null,
        shorts: [],
        current: 0,
        isLoading: false,
        nextActive: false,
        prevActive: false,
        shortsProfile: null,
        shortsHeight: 0,
        shortsMargin: window.innerWidth < 999 ? 0 : 40,
        animationScroll: 0,

        firstTouch: 0,
        xUp: 0,
        yUp: 0,
        xDown: 0,
        yDown: 0,
        xDiff: 0,
        yDiff: 0,

        videoElement: null,
        mounted() {
            this.videoElement = document.createElement('video');
            this.shortsProfile = this.$refs.profileElement;
            lazyScripts.loadHls().then(() => {
                this.loaded();
                this.events();
            });
        },
        loaded() {
            this.shortsHeight = this.shortsProfile.offsetHeight;

            this.nativeHlsed = this.videoElement.canPlayType('application/vnd.apple.mpegURL') || this.videoElement.canPlayType('audio/mpegurl');

            if(!this.nativeHlsed && Hls.ised()) {
                this.newHlsInstance();
            }

            if(this.service.short) {
                let short = this.service.short;
                short.playing = true;
                short.muted = true;
                short.videoElement = null;
                short.viewed = false;
                short.shouldRender = true;
                this.shorts.push(short);

                this.markAsViewed(short).then();
            }

            this.loadNext().then(() => {
                if(typeof this.shorts[1] !== 'undefined') {
                    this.shorts[1].shouldRender = true;
                }
            });

            if(this.device.mobile) {
                document.documentElement.style['overscroll-behavior'] = 'none';
                document.documentElement.style.overflow = 'hidden';
            }

            window.addEventListener('popstate', (event) => {
                const key = event.state ? event.state.key : 0;

                if(key > this.current) {
                    this.animationScroll = this.animationScroll - (this.shortsHeight + this.shortsMargin);
                } else {
                    this.animationScroll = this.animationScroll + (this.shortsHeight + this.shortsMargin);
                }

                this.switchVideo(key, false);
            });
        },
        events() {

            this.shortsProfile.addEventListener('touchstart', (evt) => {
                this.firstTouch = (evt.touches || evt.originalEvent.touches)[0];
                this.xDown = this.firstTouch.clientX;
                this.yDown = this.firstTouch.clientY;
            }, { ive: true });

            this.shortsProfile.addEventListener('touchmove', (evt) => {
                if ( !this.xDown || !this.yDown ) {
                    return;
                }
                this.xUp = evt.touches[0].clientX;
                this.yUp = evt.touches[0].clientY;

                this.xDiff = this.xDown - this.xUp;
                this.yDiff = this.yDown - this.yUp;

                if ( Math.abs( this.xDiff ) < Math.abs( this.yDiff ) ) {
                    if ( this.yDiff > 0 ) {
                        /* up swipe */
                        this.nextShort();
                    } else {
                        /* down swipe */
                        this.prevShort();
                    }
                }
                this.xDown = 0;
                this.yDown = 0;
            }, { ive: true });

        },
        newHlsInstance() {
            this.hlsObject = new Hls({
                startLevel: this.currentLevel,
                manifestLoadPolicy: {
                    default: {
                        maxTimeToFirstByteMs: 1000,
                        maxLoadTimeMs: 1500,
                        timeoutRetry: {
                            maxNumRetry: 2,
                            retryDelayMs: 0,
                            maxRetryDelayMs: 0,
                        },
                        errorRetry: {
                            maxNumRetry: 1,
                            retryDelayMs: 500,
                            maxRetryDelayMs: 1000,
                        },
                    },
                },
                playlistLoadPolicy: {
                    default: {
                        maxTimeToFirstByteMs: 1000,
                        maxLoadTimeMs: 1500,
                        timeoutRetry: {
                            maxNumRetry: 2,
                            retryDelayMs: 0,
                            maxRetryDelayMs: 0,
                        },
                        errorRetry: {
                            maxNumRetry: 2,
                            retryDelayMs: 500,
                            maxRetryDelayMs: 1000,
                        },
                    },
                },
                fragLoadPolicy: {
                    default: {
                        maxTimeToFirstByteMs: 3000,
                        maxLoadTimeMs: 6000,
                        timeoutRetry: {
                            maxNumRetry: 4,
                            retryDelayMs: 0,
                            maxRetryDelayMs: 0,
                        },
                        errorRetry: {
                            maxNumRetry: 6,
                            retryDelayMs: 500,
                            maxRetryDelayMs: 1000,
                        },
                    },
                },
            });

            this.hlsObject.on(Hls.Events.LEVEL_LOADED, (event, data) => {
                this.currentLevel = data.level;
            });

        },


        async togglePlay(short) {
            if(this.isLoading) {
                return;
            }

            /** @var {HTMLVideoElement|null} */
            const videoElement = short.videoElement;

            if(!videoElement) {
                return;
            }

            if(videoElement.paused) {
                await videoElement.play();
                short.playing = true;
            } else {
                videoElement.pause();
                short.playing = false;
            }
        },

        toggleMute (short) {
            /** @var {HTMLVideoElement|null} */
            const videoElement = short.videoElement;

            if(!videoElement) {
                return;
            }

            if(videoElement.muted) {
                videoElement.muted = false;
                short.muted = false;
            } else {
                videoElement.muted = true;
                short.muted = true;
            }
        },

        prevShort() {
            const newKey = this.current - 1;

            if(this.prevActive && !this.isLoading && typeof this.shorts[newKey] !== 'undefined' && this.shorts[newKey].videoElement) {
                this.animationScroll = this.animationScroll + (this.shortsHeight + this.shortsMargin);
                this.switchVideo(newKey);
            }
        },
        nextShort() {
            console.log("nextShort")
            const newKey = this.current + 1;
            if (this.nextActive && !this.isLoading && typeof this.shorts[newKey] !== 'undefined' && this.shorts[newKey].videoElement) {
                this.animationScroll = this.animationScroll - (this.shortsHeight + this.shortsMargin);
                this.switchVideo(newKey);
            }
        },
        switchVideo (key, pushState = true) {
            this.isLoading = true;

            let shouldResetVideoRenders = true;
            if(key + 1 === this.shorts.length) {
                shouldResetVideoRenders = false;
                this.loadNext().then(() => {
                    this.resetVideoRenders();
                });
            }

            const oldCurrent = this.shorts[this.current];
            const oldCurrentIsPlaying = !oldCurrent.videoElement.paused;
            const oldCurrentIsMuted = oldCurrent.videoElement.muted;

            if(oldCurrentIsPlaying) {
                oldCurrent.videoElement.pause();
            }

            const newCurrent = this.shorts[key];
            const oldHlsObject = this.hlsObject;

            if(this.hlsObject && newCurrent.video.hls) {
                this.newHlsInstance();
                this.hlsObject.loadSource(newCurrent.video.hls);
                this.hlsObject.attachMedia(newCurrent.videoElement);
            } else {
                newCurrent.videoElement.load();

                try {
                    newCurrent.videoElement.play();
                } catch (err) {
                    newCurrent.playing = false;
                }
            }

            if(oldHlsObject) {
                oldHlsObject.destroy();
            }

            newCurrent.playing = true;
            newCurrent.videoElement.muted = this.isWebkit ? true : oldCurrentIsMuted;
            newCurrent.muted = this.isWebkit ? true : oldCurrentIsMuted;

            this.current = key;

            if(pushState) {
                history.pushState({ key: key }, newCurrent.title, newCurrent.link);
            }

            document.title = newCurrent.title;

            this.markAsViewed(newCurrent).then(() => {});

            this.prevActive = this.current > 0;

            if(shouldResetVideoRenders) {
                this.nextActive = (this.current + 1) < this.shorts.length;
                this.resetVideoRenders();
            }

            this.isLoading = false;

            setTimeout(function() {
                oldCurrent.playing = false;
            }, 200);
        },

        async loadNext() {
            const response = await http.post('/service/next-short.json', {
                hashes: this.shorts.map((short) => short.hash)
            });

            if(typeof response.short !== 'undefined') {
                let short = response.short;
                short.playing = false;
                short.muted = true;
                short.videoElement = null;
                short.shouldRender = false;
                this.shorts.push(short);
            }

            this.nextActive = (this.current + 1) < this.shorts.length;
        },
        async markAsViewed(short) {
            if(short.viewed) {
                return;
            }
            const response = await http.post('/service/short-viewed.json', {
                hash: short.hash
            });
            if(response.success) {
                short.viewed = true;
            }
        },

        resetVideoRenders() {
            this.shorts.forEach((short, key) => {
                short.shouldRender = Math.abs(key - this.current) < 2;
            });
        }


    }
};
